/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies
 */
import { RichText, useBlockProps } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */

export default function save( props ) {
	const { attributes, className } = props;
	const {
		fontSize,
		linkTarget,
		rel,
		style,
		text,
		title,
		url,
		blockClientId,
	} = attributes;

	if ( ! text ) {
		return null;
	}

	const buttonClasses = classnames(
		'gutenify-button-link',
		'wp-block-button__link'
	);

	// The use of a `title` attribute here is soft-deprecated, but still applied
	// if it had already been assigned, for the sake of backward-compatibility.
	// A title will no longer be assigned for new or updated button block links.

	const wrapperClasses = classnames( className, {
		[ `has-custom-font-size` ]: fontSize || style?.typography?.fontSize,

	}, 'wp-block-button', `gutenify-section-${ blockClientId }` );

	return (
		<div { ...useBlockProps.save( { className: wrapperClasses } ) }>
			<RichText.Content
				tagName="a"
				className={ buttonClasses }
				href={ url }
				title={ title }
				value={ text }
				target={ linkTarget }
				rel={ rel }
			/>
		</div>
	);
}
